import React from 'react';
import { Section } from './ui/Section';
import { trackEvent } from '../utils/metaPixel';
export function FinalCTA() {
  const scrollToPricing = () => {
    trackEvent('ViewContent', {
      content_name: 'final_cta_click',
      content_category: 'cta'
    });
    const el = document.getElementById('pricing');
    if (el) {
      el.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };
  return <Section variant="alt" data-id="element-131">
      <div className="text-center" data-id="element-132">
        <button onClick={scrollToPricing} className="font-heading bg-gradient-gold hover:opacity-90 text-brand-bg font-bold text-xl md:text-2xl py-5 px-10 rounded-2xl transition-all hover:scale-105 active:scale-95 shadow-gold-glow-lg w-full md:w-auto tracking-wide" data-id="element-133">
          🚀 ¡QUIERO ENSEÑAR MEJOR DESDE HOY!
        </button>
      </div>
    </Section>;
}